import { useMemo } from "react";

export const useEmployeeSearch = (
  employeeData,
  searchQuery
) => {
  return useMemo(() => {
    if (!searchQuery) {
      return employeeData;
    }

    return employeeData.filter(
      (user) =>
        user.employee_full_name
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        user.employee_id
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase())
    );
  }, [employeeData, searchQuery]);
};